import styled from 'styled-components';

const Button = styled.button`
  padding: 8px 25px;
  width: 100%;
  margin-right: 0;
  font-family: 'RobotoBold';
  font-size: 18px;
  background-color: #ddd;
  border: 2px solid silver;
  border-right-color: #6c6c6c;
  border-bottom-color: #6c6c6c;
  color: #000000;
`;

export default Button;
